<script>
import { pickBy } from 'lodash'
import SeoMixin from '~/sites/cvb/mixins/SeoMixin'

export default {
  extends: SeoMixin,
  methods: {
    canonicalPath(path) {
      const defaultLocale = this.$env.DEFAULT_LOCALE
      const defaultLocalePrefix = `/${defaultLocale}`

      if (!defaultLocale || !path || !path.startsWith(defaultLocalePrefix)) {
        return path
      }

      if (path === defaultLocalePrefix || path.startsWith(`${defaultLocalePrefix}/`)) {
        return path.replace(defaultLocalePrefix, '') || '/'
      }

      return path
    },
    createFullPathWithoutBlacklistedParameters({
      path = null,
      additionalBlacklist = [],
      additionalParameters = {},
    } = {}) {
      if (!path) {
        path = this.$route.path
      }
      path = this.canonicalPath(path)

      const blacklist = this.$themeSettings.global.blacklistedCanonicalParameters
      blacklist.push(...additionalBlacklist)

      const allParameters = Object.assign({}, this.$route.query, additionalParameters)
      let amendedQuery = pickBy(allParameters, function(value, key) {
        return !blacklist.includes(key)
      })
      const queryArray = []
      for (let key in amendedQuery) {
        if (amendedQuery.hasOwnProperty(key)) {
          queryArray.push(key + '=' + amendedQuery[key])
        }
      }
      const encodedQuery = encodeURI(queryArray.join('&'))
      return encodedQuery ? `${path}?${encodedQuery}` : path
    },
    getSeoMetaAttrsCustom(data) {
      return {
        script: [],
      }
    },
    getSeoLinkCanonical() {
      return [
        {
          rel: 'canonical',
          href: this.canonicalLinkUrl(),
        },
      ]
    },
    getSeoMetaMain() {
      return [
        { itemprop: 'url', content: this.makeAbsoluteUrl('/') },
        { itemprop: 'name', content: this.getSeoShortTitle() },
      ]
    },
    getSeoMetaUrl() {
      return [{ property: 'og:url', content: this.canonicalLinkUrl() }]
    },
  },
}
</script>
